import { DESK_OWNER_IDENTITY, DEFAULT_PROVIDER } from './configuration/ConfigurationController';
import { LimeProvider } from './configuration/channels/blipdesk/BlipDeskController';
const BLOCK_TOOLS_KEY = 'block-tools';
export class DeskConfigurationService {
    static $inject = ['ConfigurationsService', 'CacheService', 'MESSAGINGHUBDOMAIN'];
    constructor(ConfigurationsService, CacheService, MESSAGINGHUBDOMAIN) {
        this.ConfigurationsService = ConfigurationsService;
        this.CacheService = CacheService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    /**
     * Check if desk features should be unavailable
     *
     * @returns if a channel other than BLiP Desk is currently connected
     */
    async shouldBlockTools(application, useConfigurationsApplication = false) {
        try {
            const shouldBlockToolsCache = this.CacheService.get(`${application.shortName}:${BLOCK_TOOLS_KEY}`);
            if (shouldBlockToolsCache !== undefined) {
                return shouldBlockToolsCache;
            }
        }
        catch (e) {
            console.error(e);
        }
        try {
            const ownerConfiguration = await this.ConfigurationsService.get(`${DESK_OWNER_IDENTITY}.${this.MESSAGINGHUBDOMAIN}`, undefined, useConfigurationsApplication);
            const isBlipDeskOrNoneConnected = !ownerConfiguration ||
                (ownerConfiguration[DEFAULT_PROVIDER]
                    && ownerConfiguration[DEFAULT_PROVIDER] === LimeProvider)
                || ownerConfiguration[DEFAULT_PROVIDER] === undefined;
            const shouldBlockTools = !isBlipDeskOrNoneConnected;
            try {
                this.CacheService.add(`${application.shortName}:${BLOCK_TOOLS_KEY}`, shouldBlockTools);
            }
            catch (e) {
                console.error(e);
            }
            return shouldBlockTools;
        }
        catch (e) {
            return false;
        }
    }
    /**
     * Set block-tools' cache value
     *
     * @param application - bot's application
     * @param value - cache's boolean value
     */
    setBlockToolsCache(application, value) {
        this.CacheService.add(`${application.shortName}:${BLOCK_TOOLS_KEY}`, value);
    }
    async getDeskConfiguration(key, defaultValue = undefined, useConfigurationsApplication = false) {
        try {
            const deskConfiguration = await this.ConfigurationsService.get('postmaster@desk.msging.net', undefined, useConfigurationsApplication);
            if (!key ||
                !deskConfiguration[key] ||
                deskConfiguration[key].toLowerCase() === 'null') {
                return defaultValue;
            }
            if (typeof deskConfiguration[key] === 'boolean') {
                deskConfiguration[key] = deskConfiguration[key].toString();
            }
            if (deskConfiguration[key].toLowerCase() === 'true') {
                deskConfiguration[key] = true;
            }
            else if (deskConfiguration[key].toLowerCase() === 'false') {
                deskConfiguration[key] = false;
            }
            return deskConfiguration[key];
        }
        catch (err) {
            console.error(err);
        }
    }
}
DeskConfigurationService.$inject = ['ConfigurationsService', 'CacheService', 'MESSAGINGHUBDOMAIN'];
